import { UNDO_DONE, UNDO_SENDING, UNDO_WAITING } from './constants';
import { APP_RESET } from '../App/constants';

/**
 * The move waiting for its Undo, or null: { title, words, swap, attach, sendsAt }; once it's on its way, only what
 * it shows done on the board (`swap`, `attach`, still shown until the game answers) and `sending`.
 */
function reducer(state = null, action) {
  switch (action.type) {
    case UNDO_WAITING:
      return action.payload;
    case UNDO_SENDING:
      return state && { swap: state.swap, attach: state.attach, sending: true };
    case UNDO_DONE:
    case APP_RESET:
      return null;
    default:
      return state;
  }
}

export default reducer;
